export const types = {
    EASY: 'easy',
    WEBGL: 'webgl',
    CSS3D: 'css3d',
    CANVAS: 'canvas',
    FLASH: 'flash',
    CUBE: 'cube',
    EQUIRECTANGULAR: 'equirectangular',
}

export const allowedZooms = {
    // cube: [],
    easy: [0, 2, 3, 4, 5],
    equi: [3],
    webgl: [0, 2, 3, 4, 5],
    canvas: [0, 2, 3, 4, 5],
    css3d: [0, 2, 3, 4, 5],
}
